import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {userSelector, updateUser, clearState, uploadImage, getUser} from "../../store/slices/userSlice";
import {useForm} from "react-hook-form";

import "./settings.css"

function Profile() {
    const {register, handleSubmit, setValue} = useForm();
    const {isSuccess, isError, errorMessage} = useSelector(
        userSelector
    );
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [uploading, setUploading] = useState(false)

    const dispatch = useDispatch();

    const onSubmit = (data) => {
        dispatch(updateUser(data));
    };

    const uploadImg = async (data) => {
        const file = data.file?.[0];
        
        if (!file) {
            setError('Please select an image file');
            return;
        }

        // Валідація типу файлу
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
        if (!allowedTypes.includes(file.type)) {
            setError('Please select a valid image file (JPEG, PNG, GIF, or WebP)');
            return;
        }

        // Валідація розміру файлу (5MB макс)
        if (file.size > 5 * 1024 * 1024) {
            setError('Image size must be less than 5MB');
            return;
        }

        setUploading(true);
        setError(null);
        setSuccess(null);

        try {
            const result = await dispatch(uploadImage(data));
            if (result.type === 'user/image/fulfilled') {
                // Оновлюємо дані користувача після успішного завантаження
                await dispatch(getUser());
                setSuccess('Image uploaded successfully!');
            } else {
                setError('Failed to upload image');
            }
        } catch (err) {
            setError('An error occurred while uploading the image');
        } finally {
            setUploading(false);
        }
    };

    const {currentUser} = useSelector(userSelector)

    useEffect(() => {
        if (currentUser) {
            setValue("id", currentUser.id)
            setValue("email", currentUser.email)
            setValue("nickname", currentUser.nickname)
        }

        if (isError) {
            let error
            switch (errorMessage) {
                case 'SequelizeUniqueConstraintError':
                    error = 'This nickname is already taken!';
                    break
                default:
                    error = errorMessage || 'An error occurred';
                    break
            }
            setSuccess(null)
            setError(error)
            dispatch(clearState())
        }

        if (isSuccess) {
            setError(null)
            setSuccess('Successfully updated!')
            dispatch(clearState())
        }

    }, [currentUser, isError, isSuccess, errorMessage, dispatch, setValue])

    const getImageUrl = () => {
        if (!currentUser?.image) {
            return "https://res.cloudinary.com/dluwizg51/image/upload/v1650639365/no-pic-ava_ac9buw.jpg";
        }
        
        // Використовуємо REACT_APP_UPLOAD_PATH_UI якщо доступна, або будуємо з API_BASE_URL
        if (process.env.REACT_APP_UPLOAD_PATH_UI) {
            return `${process.env.REACT_APP_UPLOAD_PATH_UI}${currentUser.image}`;
        }
        
        // Якщо API_BASE_URL закінчується на /api/, видаляємо це та додаємо /images/
        const baseUrl = process.env.REACT_APP_API_BASE_URL?.replace(/\/api\/?$/, '') || 'http://localhost:5000';
        return `${baseUrl}/images/${currentUser.image}`;
    };

    const imageBaseUrl = getImageUrl();

    return (
        <div className="container">
            <div className="col-lg-6">
                <fieldset className="p-3">
                    <div className="shadow p-3 mb-5 bg-white rounded text-center">
                        <div className="lead" style={{fontSize: "24px"}}>Profile Settings</div>
                    </div>
                    <div className="shadow p-3 mb-3 bg-white rounded text-center">
                        <img className="rounded-circle border"
                             src={imageBaseUrl} 
                             alt="User avatar"
                             style={{height: "125px", width: "125px"}}/>
                        <form method="POST" encType="multipart/form-data" onSubmit={handleSubmit(uploadImg)}>
                            <input type="file"
                                   name="file"
                                   accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                                   {...register("file")}
                                   disabled={uploading}
                            /> <br/>
                            <button 
                                style={{width: "40%"}} 
                                type="submit"
                                className="btn btn-outline-dark col-12 my-2"
                                disabled={uploading}
                            >
                                {uploading ? 'Uploading...' : 'Upload Image'}
                            </button>
                        </form>
                        <p className="text-danger">{error}</p>
                        <p className="text-success">{success}</p>
                        <div className="settingsForm my-4">
                            <form method="post" onSubmit={handleSubmit(onSubmit)}>
                                <label>User ID</label>
                                <input className="form-control"
                                       type="text"
                                       name="id"
                                       placeholder="165"
                                       {...register("id")}
                                       disabled/>
                                <label>Email</label>
                                <input className="form-control"
                                       type="email"
                                       name="email"
                                       placeholder="example@gmail.com"
                                       {...register("email")}
                                       disabled/>
                                <label>Nickname</label>
                                <input className="form-control"
                                       type="text"
                                       name="nickname"
                                       placeholder="Steve"
                                       {...register("nickname")}
                                       required/>
                                <br/>
                                <button className="btn btn-outline-dark col-12" type="submit">Update</button>
                            </form>
                        </div>
                    </div>

                </fieldset>
            </div>
        </div>
    );
}

export default Profile;